"use client"
import React, { useState } from "react"
import classes from "./FloatingBanner.module.scss"
import BookingModal from "@/components/Modal/bookingModal"

const FloatingBanner = ({ bookMeetingData, theme }) => {
	const [modalIsOpen, setIsOpen] = useState(false)
	const { bannerDescription, ...bookMeetingDataForModal } = bookMeetingData

	function openModal() {
		setIsOpen(true)
	}

	function closeModal() {
		setIsOpen(false)
	}

	return (
		<div
			// Задаём базовый фон и цвет текста для тёмного баннера.
			// Также подключаем стили, которые заменяют display: flex; align-items: center; justify-content: center...
			className="
        flex
        flex-col
        lg:flex-row
        items-center
        justify-center
        p-2
				/33bg-primary
      "
			// Перекрываем базовый чёрный цвет, если хотим динамически задать цвет из theme
			style={{
				backgroundColor: theme.accentBackgroundColor,
				color: theme.accentSecondaryFontColor,
			}}
		>
			<BookingModal
				bookMeetingData={bookMeetingDataForModal}
				modalIsOpen={modalIsOpen}
				openModal={openModal}
				closeModal={closeModal}
			/>

			{/* Ссылка, а не кнопка */}
			<span
				onClick={openModal}
				className="
          font-medium
					text-sm
					leading-[125%]
          underline
          hover:cursor-pointer
          mr-1
        "
				// Inline-стили для динамических значений из theme
				style={{
					color: theme.accentPrimaryFontColor,
					borderColor: theme.accentPrimaryFontColor,
					fontFamily: theme.fontFamilyPrimary,
				}}
			>
				Book a meeting
			</span>

			{/* Текст-описание */}
			{/* <div className="text-center"> */}
				<span
					className="
          font-light
					text-sm
					leading-[125%]
        "
					style={{
						fontFamily: theme.fontFamilyPrimary,
						color: theme.accentSecondaryFontColor,
					}}
				>
					{bannerDescription}
				</span>
			{/* </div> */}
		</div>
	)
}


// const FloatingBanner = ({ bookMeetingData, theme }) => {
//   const [modalIsOpen, setIsOpen] = useState(false)
//   const { bannerDescription, ...bookMeetingDataForModal } = bookMeetingData

//   function openModal() {
//     setIsOpen(true)
//   }

//   function closeModal() {
//     setIsOpen(false)
//   }

//   return (
//     <div
//       className={classes.FloatingBanner}
//       style={{
//         backgroundColor: theme.accentBackgroundColor,
//         color: theme.accentSecondaryFontColor,
//       }}
//     >
//       <BookingModal
//         bookMeetingData={bookMeetingDataForModal}
//         modalIsOpen={modalIsOpen}
//         openModal={openModal}
//         closeModal={closeModal}
//       />
//       <a
//         onClick={openModal}
//         className={classes.highlight}
//         style={{
//           color: theme.accentPrimaryFontColor,
//           borderColor: theme.accentPrimaryFontColor,
//           fontFamily: theme.fontFamilyPrimary,
//         }}
//       >
//         Book A Meeting
//       </a>
//       <div style={{ textAlign: "center" }}>
//         &nbsp;
//         <span
//           style={{
//             fontFamily: theme.fontFamilyPrimary,
//             color: theme.accentSecondaryFontColor,
//           }}
//         >
//           {bookMeetingData.bannerDescription}
//         </span>
//       </div>
//     </div>
//   )
// }

export default FloatingBanner
